"use strict";

// Vue
import Vue from 'vue';

// Services
import { arrayLoop } from 'services/array';

import {
  requestBecomeReviewer,
  getReviewerRequests,
  getReviewerRequestById,
  submitReviewerRequestDecision,
} from 'api/reviewer';

// State
const state = {
  requests: {
    next: ``,
    count: 0,
    results: {},
  },
};

// Getters
const getters = {
  reviewerRequests: state => state.requests,
  reviewerRequestById: state => id => state.requests.results[id] || {},
  reviewerRequestsLength: (state, getters) => Object.keys(getters.reviewerRequests.results).length,
  reviewerRequestsTotal: state => state.requests.count,
};

// Mutations
const mutations = {
  CLEAR_REQUESTS (state) {
    Vue.set(state.requests, `results`, {});

    state.requests.next = ``;
    state.requests.count = 0;
  },
  UPDATE_REQUESTS (state, { results, next, count }) {
    arrayLoop(results, (i, result) => Vue.set(state.requests.results, result.id, result));

    state.requests.next = next;
    state.requests.count = count;
  },
  RESET_ON_LOGOUT (state) {
    Vue.set(state, `requests`, {
      next: ``,
      count: 0,
      results: {},
    });
  },
};

// Actions
const actions = {
  requestBecomeReviewer({ dispatch }, model) {
    return new Promise((resolve, reject) => {
      requestBecomeReviewer(model)
        .then(res => {
          dispatch(`auth/updateUserProfileValue`, { key: `has_applied_for_reviewer_privileges`, value: true }, { root: true });
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getReviewerRequests({ commit }, url = false) {
    if (!url) {
      commit(`CLEAR_REQUESTS`);
    }

    return new Promise((resolve, reject) => {
      getReviewerRequests(url)
        .then(res => {
          const data = res.data || {};
          const results = data.results || [];

          if (results.length) {
            commit(`UPDATE_REQUESTS`, data);
          }
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getReviewerRequestById(context, id) {
    return getReviewerRequestById(id);
  },
  submitReviewerRequestDecision(context, model) {
    return submitReviewerRequestDecision(model);
  },
  resetOnLogout({ commit }) {
    commit(`RESET_ON_LOGOUT`);
  },
};

// Export
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./client/store/reviewer.js